import { useEffect } from "react";
import { useSelector } from "react-redux";
import useDebouncedSearch from "../hooks/useDebouncedSearch";
import styles from "../styles/menuAddProductModal.module.css";
import { SearchInstance } from "../utils/searchClass";
import { VenueInstance } from "../utils/venueClass";
import { MenuAddSearchList } from "./menuAddSearchList";

export const MenuAddProductModal = ({ onClose }: { onClose: any }) => {
  const { searchType, searchResults } = useSelector((state: any) => state.search);
  const { activeBusiness } = useSelector((state: any) => state.business);

  const { searchInput, debouncedSearchTerm, setSearchInput } = useDebouncedSearch();

  useEffect(() => {
    if (debouncedSearchTerm) {
      SearchInstance.setSearchQuery(debouncedSearchTerm);
    }
  }, [debouncedSearchTerm]);

  const handleSearchTypeChange = (event: any) => {
    const searchType = event.target.value;
    console.log(searchType, "searchType");
    SearchInstance.setSearchType(searchType, setSearchInput);
  };

  const handleSearchQueryChange = (event: any) => {
    setSearchInput(event.target.value);
  };

  const renderSearchPlaceholder = () => {
    switch (searchType) {
      case "brand":
        return "Search by brand name";
      case "product":
        return "Search by product name";
      default:
        return "Search brands and products";
    }
  };

  const handleAddMenuItem = async (product: Product) => {
    await VenueInstance.addMenuItem(activeBusiness.id, product);
  };

  return (
    <div className={styles.wrapper}>
      {/* HEADER */}
      <div className={styles.header}>
        <h2 onClick={onClose}>Add Menu Item</h2>
        <div className={styles.searchFilterWrapper}>
          <div className={styles.search}>
            <input
              value={searchInput}
              type="text"
              placeholder={`${renderSearchPlaceholder()}`}
              onChange={handleSearchQueryChange}
            />
          </div>
          <div className={styles.filter}>
            <select onChange={handleSearchTypeChange}>
              <option value="all">All</option>
              <option value="brand">Brand</option>
              <option value="product">Product</option>
            </select>
          </div>
        </div>
      </div>

      {/* FILTERS TODO: ADD IN LATER */}

      {/* RESULTS */}
      <MenuAddSearchList handleAddMenuItem={handleAddMenuItem} results={searchResults} />
    </div>
  );
};
